class RequestProductSuccessModalModel {
    constructor() {
        this.requestedProducts = {};
    }
};

export default RequestProductSuccessModalModel;


// WEBPACK FOOTER //
// ./client/app/shared/system-components/request-product/model/success.modal.model.js